import { Injectable, signal } from '@angular/core';

const STORAGE_KEY = 'galaxy.dashboard.favorites';

@Injectable({ providedIn: 'root' })
export class DashboardFavoritesService {
  private readonly favoriteRoutesSignal = signal<string[]>(this.read());
  readonly favoriteRoutes = this.favoriteRoutesSignal.asReadonly();

  constructor() {
    window.addEventListener('storage', e => {
      if (e.key === STORAGE_KEY) {
        this.favoriteRoutesSignal.set(this.read());
      }
    });
  }

  isFavorite(route: string): boolean {
    return this.favoriteRoutesSignal().includes(route);
  }

  toggle(route: string): void {
    const current = this.favoriteRoutesSignal();
    const next = current.includes(route)
      ? current.filter(r => r !== route)
      : [...current, route];
    this.favoriteRoutesSignal.set(next);
    this.write(next);
  }

  private read(): string[] {
    try {
      const raw = localStorage.getItem(STORAGE_KEY);
      if (!raw) {
        return [];
      }
      const parsed: unknown = JSON.parse(raw);
      return Array.isArray(parsed)
        ? parsed.filter((item): item is string => typeof item === 'string')
        : [];
    } catch {
      return [];
    }
  }

  private write(routes: string[]): void {
    try {
      localStorage.setItem(STORAGE_KEY, JSON.stringify(routes));
    } catch {
      /* storage unavailable (e.g. private browsing quota) — ignore */
    }
  }
}
